import { render, staticRenderFns } from "./ParentContentDetailPage.vue?vue&type=template&id=4c43e0be&"
import script from "./ParentContentDetailPage.vue?vue&type=script&lang=js&"
export * from "./ParentContentDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports